const { permissions } = require('../../../../constants/permissions');

require('./userRoles.style.scss');

const MAIN_STATE = 'main';
const HELP_MAIN = 'roles-manage';
class UserRolesController {
    constructor($element, $scope, $rootScope, $filter, $timeout, $q, crudService, storageService, dialogService, notificationService, contentSwitcherService, utilsService, iamPersistenceService, protectionSetPickerPersistence) {
        this.$element = $element;
        this.$filter = $filter;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$q = $q;
        this.crudService = crudService;
        this.storageService = storageService;
        this.dialogService = dialogService;
        this.utilsService = utilsService;
        this.notificationService = notificationService;
        this.contentSwitcherService = contentSwitcherService;
        this.iamPersistenceService = iamPersistenceService;
        this.protectionSetPickerPersistence = protectionSetPickerPersistence;

        this.modalTitle = this.$filter('translate')('main.nav.top.admin.userRoles.label');
        this.configTable();
        this.animateSwitcher = typeof this.$element[0].getBoundingClientRect === 'function';

        this.selectedUser = [];
        this.subscriptionList = [];

        this.$scope.$watchCollection(
            () => this.selectedSubscription,
            (newValue, oldValue) => {
                if (!oldValue || !newValue) return;
                this.iamPersistenceService.getPermissions(newValue.managerEndpointUrl, newValue.value).then((res) => {
                    this.storageService.setTempPermissions(res);
                    this.load(true, newValue);
                });
            }
        );

        this.$rootScope.$on('role.refresh', () => {
            this.iamPersistenceService.getPermissions(this.selectedSubscription.managerEndpointUrl, this.selectedSubscription.value).then((res) => {
                this.storageService.setTempPermissions(res);
                this.storageService.setPermissions(res);
                this.$rootScope.$emit("role-change");
                this.notificationService.pop(res.message);
            });
        });
    }

    $onInit() {
        if (angular.isUndefined(this.storageService.getToken())) return;
        if (this.animateSwitcher) {
            this.minInnerHeight = this.getMinHeight();
        }
    }

    async onOpen() {
        this.helpId = HELP_MAIN;
        this.state = MAIN_STATE;
        this.busy = true;
        await this.setSubscriptionData();
    }

    load(firstPage, subscription, user) {
        this.busy = true;
        this.iamPersistenceService.getAllUsers(firstPage, subscription).then(res => {
            this.users = res.map((user, index) => {
                return {
                    uuid: user.uuid,
                    name: user.identifier,
                    type: user.authorityType,
                    role: user.roles,
                    rolesDisplay: user.roles.map(function (item) {
                        return item['displayName'];
                    }),
                    selectedRoles: user.roles.map(function (item) {
                        return item['uuid'];
                    }),
                    state: user.authorityState
                };
            });
            if (user) {
                let selectedUser = this.users.filter(item => item.uuid === user.uuid)[0];
                if (selectedUser) this.selectedUser[0] = selectedUser;
            } else {
                this.selectedUser[0] = this.users[0];
            }
            this.busy = false;
        });

        this.iamPersistenceService.getAllRoles(subscription).then(res => {
            this.roles = res.map((role => {
                return {
                    label: role.displayName,
                    name: role.name,
                    value: role.uuid
                };
            }));
        });

        this.iamPersistenceService.getDefaultRole(subscription).then(res => {
            this.defaultRole = res;
        });
    }

    async setSubscriptionData() {
        this.subscriptionList = await this.getSubscriptions();
    }

    getSubscriptions() {
        this.protectionSetPickerPersistence.getScopeSubscriptions().then((subs) => {
            this.allSubscriptions = subs;
            this.availableSubscriptions = subs.map((elem, i) => {
                return {
                    id: i,
                    label: elem.name,
                    value: elem.uuid,
                    managerEndpointUrl: elem.managerEndpointUrl
                };
            });
            this.selectedSubscription = this.availableSubscriptions.filter(pr => pr.value === this.storageService.getSubscription().uuid)[0];
        });
    }

    onModalClose() {
    }

    configTable() {
        this.userTableConfig = [
            this.$filter('translate')('main.nav.top.admin.userRoles.form.name.label'),
            this.$filter('translate')('main.nav.top.admin.userRoles.form.type.label'),
            this.$filter('translate')('main.nav.top.admin.userRoles.form.roles.label'),
            // this.$filter('translate')('main.nav.top.admin.userRoles.form.state.label'),
        ];
    }

    getMinHeight() {
        const modalBody = this.$element.find('.modal-body'),
            minHeight = modalBody[0] ? modalBody.css('min-height') : null;
        return minHeight ? (parseFloat(minHeight) - parseFloat(modalBody.css('padding-top')) - parseFloat(modalBody.css('padding-bottom'))) : null;
    }

    toggleActive() {
        if (this.selectedUser[0].state === "ACTIVE") {
            this.dialogService.showYesNo(this.$filter('translate')("main.nav.top.admin.userRoles.deactivate.text", { name: this.selectedUser[0].name, nameActive: this.storageService.getUserUuid() }), this.$filter('translate')("main.nav.top.admin.userRoles.deactivate.title"), '', 'user-deactivate')
                .then(result => {
                    if (!result) return false;
                    this.changeUserState('DEACTIVATE');
                });
        } else {
            this.dialogService.showYesNo(this.$filter('translate')("main.nav.top.admin.userRoles.activate.text", { name: this.selectedUser[0].name }), this.$filter('translate')("main.nav.top.admin.userRoles.activate.title"), '', 'user-activate')
                .then(result => {
                    if (!result) return false;
                    this.changeUserState('ACTIVATE');
                });
        }
    }

    manageUserRoles() {
        this.showUserRoleChangeDialog = true;
    }

    changeUserRole(role) {
        return this.$q((resolve) => {
            const changedUserName = this.selectedUser[0].name;
            this.iamPersistenceService.setUserRole(this.selectedUser[0].uuid, role, this.selectedSubscription).then((res) => {
                resolve();
                if (changedUserName === this.storageService.getUserUuid()) {
                    this.iamPersistenceService.getPermissions(this.selectedSubscription.managerEndpointUrl, this.selectedSubscription.value).then((res) => {
                        if (this.selectedSubscription.value === this.storageService.getSubscription().uuid) {
                            this.storageService.setTempPermissions(res);
                            this.storageService.setPermissions(res);
                            this.load(false, this.selectedSubscription, this.selectedUser[0]);
                            this.$rootScope.$emit("role-change");

                        } else {
                            this.storageService.setTempPermissions(res);
                            this.load(false, this.selectedSubscription, this.selectedUser[0]);
                            this.$rootScope.$emit("role-change");
                        }
                    });
                } else {
                    this.load(false, this.selectedSubscription, this.selectedUser[0]);
                }
                this.notificationService.pop(res.message);
            }, err => {
                resolve();
                this.busy = false;
            });
        });
    }

    manageDefaultRole() {
        this.showDefaultRoleChangeDialog = true;
    }

    changeDefaultRole(role) {
        return this.$q((resolve) => {
            this.iamPersistenceService.setDefaultRole(role, this.selectedSubscription).then((res) => {
                resolve();
                this.notificationService.pop(res.message);
                this.load(false, this.selectedSubscription);
            }, err => {
                this.busy = false;
            });
        });
    }

    changeUserState(action) {
        if (action === 'ACTIVATE') {
            this.iamPersistenceService.activateUser(this.selectedUser[0].uuid, this.selectedSubscription).then(res => {
                this.notificationService.pop(res.message);
                this.load(false, this.selectedSubscription);
            });
        } else {
            this.iamPersistenceService.deactivateUser(this.selectedUser[0].uuid, this.selectedSubscription).then(res => {
                this.notificationService.pop(res.message);
                this.load(false, this.selectedSubscription);
            });
        }
    }

    setGrid(grid) {
        this.grid = grid;
        this.ctxGridStyleConfig = {
            multiselect: false,
            columnsWidthMapInPct: []
        };
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('40%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('17%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('43%');
        // this.ctxGridStyleConfig.columnsWidthMapInPct.push('15%');


        this.$timeout(() => {
            this.gridColumnsStyleConfig = this.ctxGridStyleConfig;
            this.gridFlag = true;
        }, 0);
    }

    isDefaultRoleVisible() {
        return this.iamPersistenceService.hasPermissions(permissions.DEFAULT_ROLE_GET, true);
    }

    isEditRoleDisabled() {
        return !this.hasEditDefaultRolePermissions();
    }

    isUserDeactivateDisabled() {
        return !this.hasUserDeactivatePermissions() || (this.selectedUser && this.selectedUser.length > 0 &&
            (this.isCurrentUserSelected() || this.selectedUser[0].type === 'SERVICE_PRINCIPAL'));
    }

    // isUserActivateDisabled() {
    //     return !this.iamPersistenceService.hasPermissions(permissions.USER_ACTIVATE, true) || (this.selectedUser && this.selectedUser.length > 0 && this.selectedUser[0].type === 'SERVICE_PRINCIPAL');
    // }

    isEditDefaultRoleDisabled() {
        return !this.hasEditRolePermissions();
    }

    isUsersVisible() {
        return this.iamPersistenceService.hasPermissions(permissions.USER_LISTING, true);
    }

    hasEditDefaultRolePermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.ROLE_EDIT, true);
    }

    hasEditRolePermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.DEFAULT_ROLE_SET, true);
    }

    hasUserDeactivatePermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.USER_DEACTIVATE, true);
    }

    isCurrentUserSelected() {
        return this.selectedUser && this.selectedUser.length > 0 && this.selectedUser[0].name === this.storageService.getUserUuid();
    }
}

UserRolesController.$inject = ['$element', '$scope', '$rootScope', '$filter', '$timeout', '$q', 'crudService', 'storageService', 'dialogService', 'notificationService', 'contentSwitcherService', 'utilsService', 'iamPersistenceService', 'protectionSetPickerPersistence'];

const userRolesComponent = {
    controller: UserRolesController,
    template: require('./userRoles.template.html'),
    bindings: {
        showModal: '='
    }
};

module.exports = userRolesComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/mainApp/dialogs/userRoles/userRoles.component.js